
export default (criteria)=>{
    global.appFlow.afterBooted(criteria);
    global.appFlow.afterLoggedIn(criteria);
}